import React from 'react'
import { CardStyle } from './style'

type ObjCourse = {
  courseName: string
  _id: string
}

type user = {
  _id: string
  name: string
  cpf: string
  email: string
  cellPhone: string
  courses: ObjCourse[]
  isConfirmed: boolean
  confirmCode: string
  updateAt: string
  createAt: string
  __v: number
}

type CardProps = React.FC<{
  usersArrays: user[]
}>

export const Card: CardProps = ({ usersArrays }) => {
  return (
    <CardStyle>
      {usersArrays.map((user, index) => (
        <div key={index + 1}>
          <p>Data do Cadastro: {user.createAt}</p>
          <p>Nome: {user.name}</p>
          <p>CPF: {user.cpf}</p>
          <p>Email: {user.email}</p>
          <p>Celular: {user.cellPhone}</p>
          <p>Curso(s) de Interesse:</p>
          <ul>
            {user.courses.map((course, index) => {
              return <li key={index + 1}>{course.courseName}</li>
            })}
          </ul>
          <p>Cadastro validado: {user.isConfirmed ? 'SIM' : 'NÃO'}</p>
        </div>
      ))}
    </CardStyle>
  )
}
